'use strict';

angular
  .module('kerp-forms.forms')
  .factory('MRR_FORM', ['FormUI', function (FormUI) {
    var formUI = new FormUI();

    var form = [
      {
        type: 'section',
        condition: 'model.page === 1',
        page: 1,
        items: [
          {
            type: 'template',
            template: '<div><h3>Guidance notes for requesting a Mandatory Reconsideration (MR)</h3><p><strong>Please note:</strong> For most benefits, a Mandatory Reconsideration (MR) request is the first and compulsory step in the appeal process. You cannot lodge an appeal against a decision without first going through the MR stage.</p><p><a href=" https://www.youtube.com/watch?v=dVaGWAyWC8g" title="MR: What is MR?">Watch this video to find out what Mandatory Reconsideration is and why you need to apply for it.</a></p><p>When giving grounds for your request you must give clear information/reasons for your disagreement. It is not enough to say that you disagree with the decision because you think it is unfair. For example, if you have been found fit for work or are disputing a Personal Independence Payment decision, you could say something like: "I disagree with your decision because I think I should score more points for mobility difficulties". Or if you disagree with how your benefit has been calculated you could say: "I think you have got the figures for my savings wrong".</p><p>If the decision relates to your health try to focus on the impact your condition has on your ability to carry out various functions, rather than the condition itself.</p> <p>Make sure your MR request reaches the office that made the original decision within one month of the date of the decision. If your request is likely to be late then state the possible reasons for this delay.</p><p>The DWP would like you to send in further information with your requests. However, it is recommended that you do not send any further information until you have discussed it with a Benefit Adviser. The most important thing at this stage of your dispute is to request the Mandatory Reconsideration as soon as possible. Further information and evidence can always be sent at a later stage.</p><p>A request for a Mandatory Reconsideration is likely to lead to you getting a phone call from a decision maker. As part of this phone call the decision maker will attempt to explain the reasons why the decision was made. It is important that you remain strong and determined at this point. The DWP hopes that such a verbal explanation will stop people from continuing with their dispute. Therefore, you should clearly state that you wish to carry on with the Mandatory Reconsideration and want any further decisions sent to you in writing.</p></div>'
          },
          {
            type: 'template',
            template: '<div><h2 class=\'formPartTitle\'>1. About you</h2><p><a href="https://www.youtube.com/watch?v=JGt22SUuSzI" title="MR: How to fill in the MR form">Watch this video for advice on how to fill in the Mandatory Reconsideration form.</a></p></div>'
          },
          {
            key: '1_1',
            title: 'Title',
            type: 'select',
            titleMap: [
              {"value": "Mr", "name": "Mr"},
              {"value": "Mrs", "name": "Mrs"},
              {"value": "Miss", "name": "Miss"},
              {"value": "Ms", "name": "Ms"}
            ]
          },
          {
            key: '1_2',
            title: 'Surname'
          },
          {
            key: '1_3',
            title: 'All other names',
            type: 'textarea'
          },
          {
            key: '1_4',
            required: true,
            type: 'memorabledate',
            title: 'Date of birth',
            validationMessage: 'The date of birth is incorrect',
            maxDate: new Date()
          },
          {
            key: '1_5',
            title: 'National Insurance (NI) number'
          },
          {
            key: '1_6',
            title: 'Your present address'
          },
          {
            key: '1_7',
            title: ''
          },
          {
            key: '1_8',
            title: ''
          },
          {
            key: '1_9',
            title: 'Postcode'
          },
          {
            key: '1_10',
            title: 'Daytime phone Number'
          }
        ]
      },
      {
        type: 'section',
        condition: 'model.page === 2',
        page: 2,
        items: [
          {
            type: 'help',
            helpvalue: '<div><h2 class=\'formPartTitle\'>2. About a child</h2></div>'
          },
          {
            type: 'help',
            htmlClass: 'alert alert-success',
            helpvalue: '<div>If this reconsideration is about a child’s benefit decision, please give all their details:</div>'
          },
          {
            key: '2_0',
            title: 'Is this reconsideration about a child’s benefit decision?',
            type: 'radios',
            titleMap: [{value: 'no', name: 'No'}, {value: 'yes', name: 'Yes'}]
          },
          {
            type: 'section',
            condition: 'model["2_0"] === "yes"',
            page: 2,
            items: [
              {
                key: '2_1',
                title: 'Child’s name'
              },
              {
                key: '2_2',
                type: 'memorabledate',
                title: 'Child’s date of birth',
                validationMessage: 'The date of birth is incorrect',
                required: true,
                maxDate: new Date()
              },
              {
                key: '2_3',
                title: 'Child’s N.I. number (if they have one)'
              }
            ]
          }
        ]
      },
      {
        type: 'section',
        condition: 'model.page === 3',
        page: 3,
        items: [
          {
            type: 'help',
            helpvalue: '<div><h2 class=\'formPartTitle\'>3. About your representative</h2></div>'
          },
          {
            type: 'help',
            htmlClass: 'alert alert-success',
            helpvalue: '<div>If you have arranged for someone to represent you, please give their details here</div>'
          },
          {
            key: '3_0',
            title: 'Have you arranged for someone to represent you?',
            type: 'radios',
            titleMap: [{value: 'no', name: 'No'}, {value: 'yes', name: 'Yes'}]
          },
          {
            type: 'section',
            condition: 'model["3_0"] === "yes"',
            page: 2,
            items: [
              {
                key: '3_1',
                title: 'Their full name'
              },
              {
                key: '3_2',
                title: 'Their address'
              },
              {
                key: '3_3',
                title: 'Their phone number'
              }
            ]
          }
        ]
      },
      {
        type: 'section',
        condition: 'model.page === 4',
        page: 4,
        items: [
          {
            type: 'help',
            helpvalue: '<div><h2 class=\'formPartTitle\'>4. About the decision</h2></div>'
          },
          {
            key: '4_1',
            title: 'Name of the benefit'
          },
          {
            key: '4_2',
            title: 'Date at the top of the letter about the decision',
            type: 'kerpdate',
            mode: 'month',
            validationMessage: 'You have to pick a valid date',
            required: true,
            maxDate: new Date()
          },
          {
            type: 'help',
            helpvalue: '<div><h2 class=\'formPartTitle\'>5. Reasons</h2></div>'
          },
          {
            key: '5_1',
            title: 'Use this space to say why you don’t agree with the decision',
            type: 'textarea'
          },
          {
            type: 'template',
            template: '<div><h3>Guidance notes for requesting a Mandatory Reconsideration (MR)</h3><p><strong>Please note:</strong> For most benefits, a Mandatory Reconsideration (MR) request is the first and compulsory step in the appeal process. You cannot lodge an appeal against a decision without first going through the MR stage.</p><p><a href=" https://www.youtube.com/watch?v=dVaGWAyWC8g" title="MR: What is MR?">Watch this video to find out what Mandatory Reconsideration is and why you need to apply for it.</a></p><p>When giving grounds for your request you must give clear information/reasons for your disagreement. It is not enough to say that you disagree with the decision because you think it is unfair. For example, if you have been found fit for work or are disputing a Personal Independence Payment decision, you could say something like: "I disagree with your decision because I think I should score more points for mobility difficulties". Or if you disagree with how your benefit has been calculated you could say: "I think you have got the figures for my savings wrong".</p><p>If the decision relates to your health try to focus on the impact your condition has on your ability to carry out various functions, rather than the condition itself.</p> <p>Make sure your MR request reaches the office that made the original decision within one month of the date of the decision. If your request is likely to be late then state the possible reasons for this delay.</p><p>The DWP would like you to send in further information with your requests. However, it is recommended that you do not send any further information until you have discussed it with a Benefit Adviser. The most important thing at this stage of your dispute is to request the Mandatory Reconsideration as soon as possible. Further information and evidence can always be sent at a later stage.</p><p>A request for a Mandatory Reconsideration is likely to lead to you getting a phone call from a decision maker. As part of this phone call the decision maker will attempt to explain the reasons why the decision was made. It is important that you remain strong and determined at this point. The DWP hopes that such a verbal explanation will stop people from continuing with their dispute. Therefore, you should clearly state that you wish to carry on with the Mandatory Reconsideration and want any further decisions sent to you in writing.</p><p><a href="https://www.youtube.com/watch?v=n5W6MpzN5Is" title="MR: What happens next?">Watch this video to find out what happens after you send your Mandatory Reconsideration request.</p></a></div>'
          }
        ]
      },
      {
        type: 'section',
        condition: 'areFormNavigationButtonsVisible()',
        htmlClass: 'text-center margin-top15',
        items: [{
          type: 'actions',
          items: [
            {type: 'button', style: 'btn-default', title: 'Previous', onClick: 'prev()'},
            {type: 'button', style: 'btn-primary', title: 'Next', onClick: 'next()'}
          ]
        }]
      }
    ];
    formUI.setForm(form);

    return formUI;
  }]);
